import { AppData } from "../../AppDataProvider";
import { ApplyDiscountCodePayload } from "../../actions";

export type ApplyDiscountCodeOpts = {
  appData: AppData;
  payload: ApplyDiscountCodePayload;
};

export const applyDiscountCode = (options: ApplyDiscountCodeOpts): AppData => {
  const { bookingData } = options.appData;

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
  };
};
